export const URL_Route = {
  Login: "/login",
  Page404: "*",

  Default: "/",
  Panel: "/panel",
  Contact_Request:"/contact-request",
  Agent_Request:"/agent-request",
  Rental_Request:"/rental-request",
  Submited_Property:"/submited-property",
  Property_List:"/property-list",
  Add_Property:"/add-property",
  Edit_Property:"/edit-property",
  Base_Info:"/base-info",
  Region_Sort:"/region-sort",
  Add_Agent:"/add-agent",
  Edit_Agent:"/edit-agent",
  List_Agent:"/list-agent",
  Change_Password:"/change-password",
  Log_Out:"/log-out",
  About_us:"/about-us",
  PanelPage404: "/*",

  test: "/test",
};
